import React, { useState } from "react";
import { useDispatch } from 'react-redux';
import { LoginForm } from './login';
import { login } from '../../api/authApi';
import { AppDispatch } from '../../api/store';
import { useNavigate, useLocation } from 'react-router-dom';
import { LocationState } from '../../interfaces/locationState';
import { useToast } from '../../hooks/useToast';
import { tempPass } from "../../utils/config";

export const LoginContainer: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { showSuccess, showError } = useToast();
  const from = (location.state as LocationState)?.from?.pathname || '/';

  const handleLogin = async (loginEmail: string, loginPassword: string) => {
    try {
      await dispatch(login({ email: loginEmail, password: loginPassword })).unwrap();
      
      // Check if user is using temporary password
      if (loginPassword === tempPass) {
        showSuccess('Please change your password');
        navigate('/change-password');
      } else {
        showSuccess('Login successful!');
        navigate(from);
      }
    } catch (error: any) {
      console.error('Login error:', error);
      showError(`${error}`);
    }
  };

  return (
    <LoginForm
      email={email}
      password={password}
      setEmail={setEmail}
      setPassword={setPassword}
      handleLogin={handleLogin}
    />
  );
};

